export const AUTHENTICATION_FAILED = "authentication_failed";

export default function*(username, password) {
  const url = "/api/oncall/public/login";
  const response = yield fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (response.ok) {
    return yield response.json();
  }
  //noinspection MagicNumberJS
  if (response.status === 401) {
    return AUTHENTICATION_FAILED;
  }
  throw new Error(response.status + ": " + response.statusText);
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/public/login.js